
const CkycDetailsCard = ({ details }) => {
    if (!details) return null;

    const pd = details.personal_details || details || {};
    const idObj = details.identity_details || {};
    const idDetails = Array.isArray(idObj) ? idObj : (idObj?.identity || []);
    const imageDetails = details.image_details?.image || [];

    const getIdentity = (type) => idDetails.find(id => id.ident_type === type)?.ident_num || '';

    // Extract photo from image_details array, base64 data, or URLs
    let photograph = null;
    if (imageDetails.length > 0) {
        const imgObj = imageDetails.find(img => img.image_code === "Photograph" || img.image_code === "01") || imageDetails[0];
        if (imgObj?.image_url) {
            photograph = imgObj.image_url;
        } else if (imgObj?.image_data) {
            photograph = imgObj.image_data.startsWith('data:')
                ? imgObj.image_data
                : `data:image/${imgObj.image_type || 'jpeg'};base64,${imgObj.image_data}`;
        }
    }
    if (!photograph && details.photo_url) photograph = details.photo_url;
    if (!photograph && details.photo) {
        photograph = details.photo.startsWith('data:') || details.photo.startsWith('http')
            ? details.photo
            : `data:image/jpeg;base64,${details.photo}`;
    }

    // Helper for Age calculation
    const calculateAge = (dob) => {
        if (!dob) return null;
        const parts = dob.split('-');
        let birthDate;
        if (parts.length === 3) {
            if (parts[0].length === 4) {
                birthDate = new Date(dob);
            } else {
                birthDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
            }
        } else {
            birthDate = new Date(dob);
        }
        if (isNaN(birthDate.getTime())) return null;
        const today = new Date();
        let calculated = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            calculated--;
        }
        return calculated > 0 ? calculated : null;
    };

    const age = pd.age || details.age || calculateAge(pd.dob) || '-';

    const perm = details.addressData?.permanent || {};
    const corres = details.addressData?.correspondence || {};

    const panNumber = pd.pan || idObj.pan || getIdentity("PAN") || '-';
    const aadhaarNumber = idObj.aadhaar_masked || getIdentity("Proof Of Aadhaar") || getIdentity("Aadhaar") || '-';

    // Build documents list
    const documents = [...idDetails];
    if (documents.length === 0) {
        if (panNumber && panNumber !== '-') {
            documents.push({ ident_type: "PAN Card", ident_num: panNumber, issue_date: '-', expiry_date: '-' });
        }
        if (aadhaarNumber && aadhaarNumber !== '-') {
            documents.push({ ident_type: "Aadhaar Card", ident_num: aadhaarNumber, issue_date: '-', expiry_date: '-' });
        }
    }

    return (
        <div className="card mt-4">
            <div className="card-body">
                <div className="row g-2 ckyc_details_container">
                    {/* Personal Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Personal Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Full Name</span><span className="w-50 text-break">{pd.full_name || '-'}</span></li>
                                        <li><span className="label w-50">Father's Name</span><span className="w-50 text-break">{pd.father_fullname || '-'}</span></li>
                                        <li><span className="label w-50">Mother's Name</span><span className="w-50 text-break">{pd.mother_fullname || '-'}</span></li>
                                        <li><span className="label w-50">Date of Birth</span><span className="w-50 text-break">{pd.dob || '-'}</span></li>
                                        <li><span className="label w-50">Age</span><span className="w-50 text-break">{age}</span></li>
                                        <li><span className="label w-50">Gender</span><span className="w-50 text-break">{pd.gender === 'M' ? 'Male' : pd.gender === 'F' ? 'Female' : pd.gender || '-'}</span></li>
                                        <li><span className="label w-50">Marital Status</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Nationality</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Occupation</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Identity Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Identity Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">PAN</span><span className="w-50 text-break">{panNumber}</span></li>
                                        <li><span className="label w-50">Aadhaar Number</span><span className="w-50 text-break">{aadhaarNumber}</span></li>
                                        <li><span className="label w-50">CKYC ID</span><span className="w-50 text-break">{pd.ckyc_no || '-'}</span></li>
                                        <li><span className="label w-50">CKYC Reference ID</span><span className="w-50 text-break">{pd.ckyc_reference_id || '-'}</span></li>
                                        <li><span className="label w-50">Other ID Type</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Other ID Number</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Issuing Authority</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Contact Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Mobile Number</span><span className="w-50 text-break">{pd.mob_code ? `+${pd.mob_code} ${pd.mob_num}` : pd.mob_num || '-'}</span></li>
                                        <li><span className="label w-50">Alternate Mobile Number</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Email ID</span><span className="w-50 text-break">{pd.email || '-'}</span></li>
                                        <li><span className="label w-50">Telephone Number</span><span className="w-50 text-break">{pd.resi_std_code ? `${pd.resi_std_code}-${pd.resi_tel_num}` : '-'}</span></li>
                                        <li><span className="label w-50">Preferred Communication</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Address Type</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Photo */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card position-relative h-100 mb-0 d-flex flex-column align-items-center justify-content-center pt-5">
                            <div className="card-header border-0 pb-0 w-100 text-start position-absolute top-0 start-0">
                                <h4 className="title">Photo</h4>
                            </div>
                            <div className="card-body d-flex flex-column align-items-center w-100 mt-3">
                                {photograph ? (
                                    <img src={photograph} alt="CKYC" className="img-fluid rounded mb-3" style={{ maxHeight: '180px', objectFit: 'contain' }} />
                                ) : (
                                    <div className="bg-light rounded mb-3 d-flex align-items-center justify-content-center" style={{ width: '150px', height: '180px' }}>
                                        <i className="fa fa-user fs-1 text-secondary"></i>
                                    </div>
                                )}
                                <span className="text-muted fs-6">Photo available in CKYC</span>
                            </div>
                        </div>
                    </div>

                    {/* Address Details */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Address Details</h4>
                            </div>
                            <div className="card-body">
                                <h5 className="text-primary fw-bold mb-3">Current Address</h5>
                                <div className="content_box_container mb-4">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">House / Flat / Building</span><span className="w-50 text-break">{pd.corres_line1 || corres.line1 || '-'}</span></li>
                                        <li><span className="label w-50">Street / Area</span><span className="w-50 text-break">{pd.corres_line2 || corres.line2 || '-'}</span></li>
                                        <li><span className="label w-50">Landmark</span><span className="w-50 text-break">{pd.corres_line3 || corres.landmark || '-'}</span></li>
                                        <li><span className="label w-50">City</span><span className="w-50 text-break">{pd.corres_city || corres.city || '-'}</span></li>
                                        <li><span className="label w-50">State</span><span className="w-50 text-break">{pd.corres_state || corres.state || '-'}</span></li>
                                        <li><span className="label w-50">Country</span><span className="w-50 text-break">{pd.corres_country || corres.country || '-'}</span></li>
                                        <li><span className="label w-50">PIN Code</span><span className="w-50 text-break">{pd.corres_pin || corres.pin || '-'}</span></li>
                                    </ul>
                                </div>

                                <h5 className="text-primary fw-bold mb-3">Permanent Address</h5>
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">House / Flat / Building</span><span className="w-50 text-break">{pd.perm_line1 || perm.line1 || '-'}</span></li>
                                        <li><span className="label w-50">Street / Area</span><span className="w-50 text-break">{pd.perm_line2 || perm.line2 || '-'}</span></li>
                                        <li><span className="label w-50">Landmark</span><span className="w-50 text-break">{pd.perm_line3 || perm.landmark || '-'}</span></li>
                                        <li><span className="label w-50">City</span><span className="w-50 text-break">{pd.perm_city || perm.city || '-'}</span></li>
                                        <li><span className="label w-50">State</span><span className="w-50 text-break">{pd.perm_state || perm.state || '-'}</span></li>
                                        <li><span className="label w-50">Country</span><span className="w-50 text-break">{pd.perm_country || perm.country || '-'}</span></li>
                                        <li><span className="label w-50">PIN Code</span><span className="w-50 text-break">{pd.perm_pin || perm.pin || '-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CKYC Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">CKYC Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li>
                                            <span className="label w-50">CKYC Status</span>
                                            <span className="w-50"><span className="badge bg-success bg-opacity-10 text-success border border-success">Active</span></span>
                                        </li>
                                        <li><span className="label w-50">Registration Date</span><span className="w-50 text-break">{pd.dec_date || '-'}</span></li>
                                        <li><span className="label w-50">Last Updated Date</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">CKYC Version</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">KYC Type</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Reporting Entity</span><span className="w-50 text-break">Central KYC Records Registry</span></li>
                                        <li><span className="label w-50">Fetched On</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">KYC Mode</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Document Details */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Document Details</h4>
                            </div>
                            <div className="card-body px-1">
                                <div className="table-responsive">
                                    <table className="table table-borderless table-sm mb-0">
                                        <thead>
                                            <tr className="border-bottom">
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Document Type</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Document Number</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Issue Date</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Expiry Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documents.map((doc, index) => (
                                                <tr key={index}>
                                                    <td className="fw-medium px-2" style={{ fontSize: '14px' }}>{doc.ident_type}</td>
                                                    <td className="fw-medium px-2" style={{ fontSize: '14px' }}>{doc.ident_num}</td>
                                                    <td className="fw-medium px-2 text-muted" style={{ fontSize: '14px' }}>{doc.issue_date || '-'}</td>
                                                    <td className="fw-medium px-2 text-muted" style={{ fontSize: '14px' }}>{doc.expiry_date || '-'}</td>
                                                </tr>
                                            ))}
                                            {documents.length === 0 && (
                                                <tr>
                                                    <td colSpan="4" className="text-center text-muted pt-3">No documents found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Other Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Other Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Source</span><span className="w-50 text-break">Central KYC Records Registry</span></li>
                                        <li><span className="label w-50">Remarks</span><span className="w-50 text-break">{pd.remarks || '-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CkycDetailsCard;
